import { fetcher } from "helpers/fetcher";

import { TGetCorpEmployeeAccessReq, TGetCorpEmployeeAccessRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getCorpEmployeeAccess = async (
  params?: TGetCorpEmployeeAccessReq
) => {
  return await fetcher<TGetCorpEmployeeAccessRes, any>(
    ENDPOINT.CORPORATION.GET_CORP_EMPLOYEE_ACCESS,
    {
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.CORPORATION.GET_CORP_EMPLOYEE_ACCESS.version,
        [API_HEADER.USER_ID]: params?.userId,
        [API_HEADER.CORP_ID]: params?.corpId,
      },
    }
  );
};

export const queryGetCorpEmployeeAccess = async (
  params?: TGetCorpEmployeeAccessReq
) => {
  return (await getCorpEmployeeAccess(params)).data;
};

queryGetCorpEmployeeAccess._key = (params?: TGetCorpEmployeeAccessReq) => [
  ENDPOINT.CORPORATION.GET_CORP_EMPLOYEE_ACCESS.url,
  params,
];
